import React from "react";
import { Box } from "@mui/material";
import StatCard from "../atoms/StatCard";

/**
 * Özet kartlar satırı (molecule). StatCard listesi.
 * @param {Array<{ label: string, value: string|number, variant?: string }>} items
 * @param {boolean} alignEnd - true ise ml: "auto" ile sağa hizalanır (header filter satırında kullanım)
 */
export default function StatCardsRow({ items, alignEnd = false }) {
  return (
    <Box
      sx={{
        display: "flex",
        gap: 1.5,
        flexWrap: "wrap",
        ...(alignEnd ? { ml: "auto" } : {}),
      }}
    >
      {items.map((item, idx) => (
        <StatCard
          key={item.label || idx}
          label={item.label}
          value={item.value}
          variant={item.variant || "default"}
        />
      ))}
    </Box>
  );
}
